/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 車色情報のリスト
 * @export
 * @interface GetCarColors200ResponseInner
 */
export interface GetCarColors200ResponseInner {
    /**
     * 車色(RGB値)
     * @type {string}
     * @memberof GetCarColors200ResponseInner
     */
    colorRgb: string;
    /**
     * 車色名
     * @type {string}
     * @memberof GetCarColors200ResponseInner
     */
    colorName: string;
}

/**
 * Check if a given object implements the GetCarColors200ResponseInner interface.
 */
export function instanceOfGetCarColors200ResponseInner(value: object): value is GetCarColors200ResponseInner {
    if (!('colorRgb' in value) || value['colorRgb'] === undefined) return false;
    if (!('colorName' in value) || value['colorName'] === undefined) return false;
    return true;
}

export function GetCarColors200ResponseInnerFromJSON(json: any): GetCarColors200ResponseInner {
    return GetCarColors200ResponseInnerFromJSONTyped(json, false);
}

export function GetCarColors200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCarColors200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'colorRgb': json['color_rgb'],
        'colorName': json['color_name'],
    };
}

export function GetCarColors200ResponseInnerToJSON(json: any): GetCarColors200ResponseInner {
    return GetCarColors200ResponseInnerToJSONTyped(json, false);
}

export function GetCarColors200ResponseInnerToJSONTyped(value?: GetCarColors200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'color_rgb': value['colorRgb'],
        'color_name': value['colorName'],
    };
}

